import { useState } from 'react';
import { FAQItem } from '../components/FAQItem';
import { faqData, IFAQItem } from "../constants/faqConstant";
import { extractTextFromReactNode } from '../utils/utils';
import { Input, InputGroup } from '../components/catalyst/input'
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid'

export const FAQPage = () => {
    const [search, setSearch] = useState('');

    const filteredData: IFAQItem[] = faqData.filter((item: IFAQItem) => {
        const query = search.toLowerCase();
        const contentText = extractTextFromReactNode(item.content).toLowerCase();
        return (
            item.title.toLowerCase().includes(query) ||
            contentText.includes(query)
        );
    });

    return (
        <>
            <div className="bg-white dark:bg-zinc-800">
                <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
                    <div className="mx-auto max-w-4xl">
                        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
                            Frequently asked questions
                        </h2>
                        <div className='my-10'>
                            <InputGroup>
                                <MagnifyingGlassIcon />
                                <Input
                                    name="search"
                                    type="text"
                                    placeholder="Search questions or answers..."
                                    aria-label="Search questions or answers..."
                                    // className="mt-6 w-full px-4 py-3 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                    value={search}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                                />
                            </InputGroup>
                            {/* <input
                                type="text"
                                placeholder="Search questions or answers..."
                                className="mt-6 w-full px-4 py-3 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            /> */}
                        </div>
                        <dl className="divide-y divide-gray-900/10">
                            <FAQItem data={filteredData} />
                        </dl>
                    </div>
                </div>
            </div>
        </>
    );
};
